<template>
  <div class="toptitle">
    <a class="title_font2" v-if="header.title_url" :href="header.title_url.url||header.title_url">{{header.title}}</a>
    <span v-else>{{header.title}}</span>
  </div>
</template>
<script>
export default {
  props: ["header"],
  mounted() {
    console.log(this.header);
  }
};
</script>
<style scoped lang='scss'>
.toptitle {
  padding: 10px 30px;
  background: #1c1d1d;
  color: white;
  font-size: 16px;
  text-align: center;
  a {
    width: 100%;
    display: inline-block;
    text-decoration: none;
    color: white;
  }
}
</style>